/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestEmailUpdateResponse
 */
export interface RequestEmailUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof RequestEmailUpdateResponse
     */
    emailUpdateRequestId: string;
}

/**
 * Check if a given object implements the RequestEmailUpdateResponse interface.
 */
export function instanceOfRequestEmailUpdateResponse(value: object): value is RequestEmailUpdateResponse {
    if (!('emailUpdateRequestId' in value) || value['emailUpdateRequestId'] === undefined) return false;
    return true;
}

export function RequestEmailUpdateResponseFromJSON(json: any): RequestEmailUpdateResponse {
    return RequestEmailUpdateResponseFromJSONTyped(json, false);
}

export function RequestEmailUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestEmailUpdateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'emailUpdateRequestId': json['emailUpdateRequestId'],
    };
}

export function RequestEmailUpdateResponseToJSON(json: any): RequestEmailUpdateResponse {
    return RequestEmailUpdateResponseToJSONTyped(json, false);
}

export function RequestEmailUpdateResponseToJSONTyped(value?: RequestEmailUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailUpdateRequestId': value['emailUpdateRequestId'],
    };
}

